import React from "react";
import { useSelector } from "react-redux";
import { Grid, Paper, Box, Divider, makeStyles } from "@material-ui/core";

import { getTeams } from "../../../store/hub/teams";
import { getShowOrganisationTotals } from "../../../store/hub/loggedInUser";
import Team from "./Team";
import TeamHeader from "./birdseye/TeamHeader";
import OrganisationConversionWidget from "./team-header/OrganisationConversionWidget";

export default function Birdseye({ updateTeamView }) {
  const classes = useStyles();
  const teams = useSelector(getTeams)();
  const showOrganisationTotals = useSelector(getShowOrganisationTotals)();
  
  return (
    <Grid container spacing={2}>
      {showOrganisationTotals && (
        <Grid item xs={12}>
          <OrganisationConversionWidget />
        </Grid>
      )}
      <Grid container item xs={12} justifyContent="flex-start" spacing={2}>
        {teams
          ? teams.map((team) => (
              <Grid item key={`team-${team.Id}`}>
                <Paper className={classes.teamPaper}>
                  <TeamHeader selectedTeam={team} updateTeamView={updateTeamView} />
                  <Divider />
                  <Box className={classes.teamBox}>
                    <Team selectedTeam={team} />
                  </Box>
                </Paper>
              </Grid>
            ))
          : null}
      </Grid>
    </Grid>
  );
}

const useStyles = makeStyles((theme) => ({
  teamPaper: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
  },
  teamBox: {
    padding: theme.spacing(1),
    marginBottom: -24,
  },
}));
